(function () {


	angular.module('app.widgets')
	.directive('plaNavBar', plaNavBar);

	plaNavBar.$inject = ['UserInfoService'];

	function plaNavBar(UserInfoService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/widgets/navbar.html',
            link: function(scope, element, attrs) {
				jQuery(window).resize();
				_topNav();
				userInfoChanged(scope, UserInfoService);
              }
        }
    }

    /** 01. Top Nav
 **************************************************************** **/
function _topNav() {
	var addActiveClass = false;

	jQuery("#topMain li.dropdown > a, #topMain li.dropdown-submenu > a").bind("click", function(e) {
		if(jQuery(this).attr('href') == '#') {
			e.preventDefault();
		}

		e.stopPropagation();

		if(jQuery(window).width() > 979) {
			return;
		}


		addActiveClass = jQuery(this).parent().hasClass("resp-active");
		jQuery("#topMain").find(".resp-active").removeClass("resp-active");

		if(!addActiveClass) {
			jQuery(this).parents("li").addClass("resp-active");
        }

		return;

	});

	// Drop Downs - do not hide on click
	// jQuery("#topHead .dropdown-menu, #topNav .mega-menu .dropdown-menu").bind("click", function(e) {
	// 	e.stopPropagation();
	// });

	jQuery(window).scroll(function() {

		if(jQuery(window).width() > 1006) {
			topMain(); // on scroll
		}

	});	
	
	if(jQuery(window).width() > 1006) {
		topMain(); // on load
	}



		// #topHead Fixes
		window._headHeight		= 81;
		window._headHeightSmall	= 30;

		function _topNavCalibrate() {

			if(jQuery("#topHead").length > 0) {
				window._headHeight 		= jQuery("header#topHead").outerHeight() + jQuery("header#topNav").outerHeight() - 10;
				window._headHeightSmall	= 66;

				jQuery('#wrapper').css({"padding-top":window._headHeight + "px"});
				jQuery('#topHead').removeClass('fixed').addClass('fixed');

				if(jQuery('#header_shadow').length > 0) {
					jQuery('#header_shadow').css({"top":window._headHeight + "px"});
				}

			} else {

				if(jQuery(window).width() < 1006) {
					//jQuery('#wrapper').css({"margin-top":"-30px"});
					jQuery('#header_shadow').css({"top":"40px"});
				} else {
					jQuery('#wrapper').css({"margin-top":"0px"});

					// From mobile back to desktop - do not leave the shadow behing
					if(jQuery(window).scrollTop() > 3) {
						jQuery('#header_shadow').css({"top":"60px"});
					} else {
						jQuery('#header_shadow').css({"top":"80px"});
					}
				}

			}

		}

		// recalibrate menu (mobile = slim mode) on resize
		jQuery(window).resize(function() {
			_topNavCalibrate();
		});	_topNavCalibrate();


	// scoll is on top!
	window.topNavSmall = false;


	function topMain() {
		var _scrollTop 		= jQuery(document).scrollTop();

		if(window.topNavSmall === false && _scrollTop > 0) {
		
			jQuery('header#topNav div.nav-main-collapse').addClass('topFix');
			jQuery('#topNav').stop().animate({ 'height':'60px'},400);
			jQuery('header#topNav div.nav-main-collapse').stop().animate({ 'margin-top':'6px'},400);
			jQuery('header#topNav button').stop().animate({ 'margin-top':'0'},100);
			jQuery('header#topNav a.logo').stop().animate({ 'margin-top':'-10px'},400);

			if(jQuery('#header_shadow').length > 0) {
				jQuery('#header_shadow').stop().animate({ 'top':window._headHeightSmall + 'px'},400);/* just a little visible */
			}

			window.topNavSmall = true;
		} 

		if(window.topNavSmall === true && _scrollTop < 3) {
			jQuery('header#topNav div.nav-main-collapse').removeClass('topFix');
			jQuery('#topNav').stop().animate({ 'height':'81px'},400);
			jQuery('header#topNav div.nav-main-collapse').stop().animate({ 'margin-top':'16px'},400);
			jQuery('header#topNav button').stop().animate({ 'margin-top':'8px'},100);
			jQuery('header#topNav a.logo').stop().animate({ 'line-height':'50px', 'margin-top':'0'},400);

			if(jQuery('#header_shadow').length > 0) {
				jQuery('#header_shadow').stop().animate({ 'top':window._headHeight + 'px'},400);
			}

			window.topNavSmall = false;
		}

	}
};

function userInfoChanged(scope, UserInfoService){
	scope.$watch(function(){
		return UserInfoService.userInfo.isAuthenticated;
	}, function(){
		scope.isUserAuthenticated = UserInfoService.userInfo.isAuthenticated;
		scope.userName = UserInfoService.userInfo.userName;
		SetPermisos(UserInfoService.userInfo.permisos);
		SetImagenCompania(UserInfoService.getCliente());
	});

	function SetImagenCompania(clienteId) {
		switch (clienteId) {
			case 4:
				scope.isAdventureClient = true;
				break;
		
			default:
				scope.isAdventureClient = false;
				break;
		}
	};

	function SetPermisos(permisos){
		
		if(!permisos) return;

		permisos.forEach((element, index, array) => {
			switch(element.permisoId){
				case 1: //Administrar
					scope.permisoAdministrar = element.ver;
					break;
				case 2: //Usuarios
					scope.permisoUsuarios = element.ver;
					break;
				case 3: //Grupos
					scope.permisoGrupos = element.ver;
					break;
				//Planillas
				case 4: //Planillas
					scope.permisoPlanillas = element.ver;
					break;
				case 5: //Creacion de Tipos de Planilla
					scope.permisoPlaTiposPlanilla = element.ver;
					break;
				case 6: //Inicializar Planilla
					scope.permisoPlaInitPlanilla = element.ver;
					break;
				case 7: //Procesar Planillas
					scope.permisoPlaProPlanilla = element.ver;
					break;
				case 9: //Comprobantes de Pago
					scope.permisoPlaComprobantePago = element.ver;
					break;
				case 10: //Cargar Vacaciones
					scope.permisoPlaCarVacaciones = element.ver;
					break;
				case 11: //Procesar Masivo
					scope.permisoPlaProcMasivo = element.ver;
					break;
				case 12: //Procesos Masivos Ejecutados
					scope.permisoPlaProcMasivoEje = element.ver;
					break;
				//Mantenimientos
				case 13: //
					scope.permisoMantenimientos = element.ver;
					break;
				case 14: //Registro de Periodos
					scope.permisoManPeriodos = element.ver;
					break;
				case 15: //Registro de Centros de Costo
					scope.permisoManCenCosto = element.ver;
					break;
				case 16: //Registro de Centros de Costo Tercer Nivel
					scope.permisoManCenCosto3Nivel = element.ver;
					break;
				case 17: //Registro de Cuentas Contables
					scope.permisoManCuentas = element.ver;
					break;
				case 18: //Registro de Empleados
					scope.permisoManEmpleado = element.ver;
					break;
				case 19: //Registro de Departamentos
					scope.permisoManDepa = element.ver;
					break;
				case 20: //Registro de Areas
					scope.permisoManAreas = element.ver;
					break;
				case 21: //Registro de Puestos
					scope.permisoManPuestos = element.ver;
					break;
				case 22: //Registro de Turnos
					scope.permisoManTurnos = element.ver;
					break;
				case 23: //Registro de Horarios
					scope.permisoManHorarios = element.ver;
					break;
				case 24: //Registro de Nacionalidades
					scope.permisoManNacionalidades = element.ver;
					break;
				case 25: //Registro de Bancos
					scope.permisoManBancos = element.ver;
					break;
				case 26: //Registro de Variables
					scope.permisoManVariables = element.ver;
					break;
				case 27: //Registro de Conceptos Devengados
					scope.permisoManDevengados = element.ver;
					break;
				case 28: //Registro de Conceptos Deducibles
					scope.permisoManDeducibles = element.ver;
					break;
				case 29: //Registro de Cantidades
					scope.permisoManCantidades = element.ver;
					break;
				case 30: //Registro de Tipos de Acciones de Personal
					scope.permisoManTipoAccionPer = element.ver;
					break;
				case 31: //Registro de Acciones de Personal
					scope.permisoManAccionPer = element.ver;
					break;
				case 32: //Registro de Feriados
					scope.permisoManFeriados = element.ver;
					break;
				//Reportes
				case 33: //Reportes
					scope.permisoReportes = element.ver;
					break;
				case 34: //Reporte General de Planilla
					scope.permisoRepGeneralPla = element.ver;
					break;
				case 35: //Reporte Previo de Planilla
					scope.permisoRepPrevPla = element.ver;
					break;					
				case 36: //Reporte Bancario BNCR
					scope.permisoRepBNCR = element.ver;
					break;
				case 37: //Libro de Salarios
					scope.permisoRepLibSalarios = element.ver;
					break;
				case 38: //Archivo Para Asociación Solidarista
					scope.permisoRepAsoSoli = element.ver;
					break;
				case 39: //Historico de Salarios
					scope.permisoRepHisSal = element.ver;
					break;
				case 40: //Reporte de Vacaciones
					scope.permisoRepVac = element.ver;
					break;
				case 41: //Reporte de Asiento de Planilla
					scope.permisoRepAsientoPla = element.ver;
					break;
				case 48: //Reporte de Planilla Por Centro de Costo
					scope.permisoRepPlaPorCC = element.ver;
					break;
				//Archivos
				case 42: //Archivos
					scope.permisoArchivos = element.ver;
					break;
				case 43: //Cargar Archivo Reloj
					scope.permisoArcCargaReloj = element.ver;
					break;
				case 44: //Datos Archivo Reloj Cargado
					scope.permisoArcDatosReloj = element.ver;
					break;
				case 45: //Cargar Archivo Asociación
					scope.permisoArcCargaAso = element.ver;
					break;
				case 46: //Datos Archivo Asociación Cargado
					scope.permisoArcDatosAso = element.ver;
					break;
				case 47: //Archivo CCSS Grandes Contribuyentes
					scope.permisoArcCCSS = element.ver;
					break;
				case 49: //Archivo BNCR
					scope.permisoArcBNCR = element.ver;
					break;
			}				
		});

	};
};

})();